import React from 'react'

const Subscribe = () => {
    return (
        <>
            <section id="subscribe-seven" className="subscribe-seven-main-block">
                <div className="container">
                    <div className="subscribe-seven-block">
                        <div className="row">
                            <div className="col-lg-6 offset-lg-3 col-md-10 offset-md-1">
                                <div className="subscribe-seven-mail-icon">
                                    <i className="flaticon-letter" />
                                </div>
                                <h3 className="subscribe-seven-title">
                                    Subscribe your <br /> Email for Newsletter
                                </h3>
                                <form className="subscribe-seven-form">
                                    <div className="form-floating mb-3">
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="floatingInput"
                                            placeholder="name@example.com"
                                        />
                                        <label htmlFor="floatingInput">Email Address</label>
                                    </div>
                                    <button type="button" className="btn btn-primary-seven">
                                        <i className="flaticon-message" /> Subscribe
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Subscribe
